export const colors = {
  white: '#FFFFFF',
  blue: '#2F4858',
  grey100: '#F6F6F6',
  grey200: '#CECECE',
  orange500: '#F26419',
};
